import { InjectionToken, Provider } from "@angular/core";
import { TableConfigService } from "../table-config.service";
import { TableConfig } from "@shared/components/table-implementation/types/table-config";
import { TABLE_DEFAULT_CONFIG } from "./table-default-config.token";
import { TableConfigStoreService } from "../table-config-store.service";
import { TableColumn } from "@shared/components/table-implementation/types/column/header.type";

function sortHeaders (tableConfig: TableConfig): TableConfig {
  const fixedHeaders: TableColumn[] = [];
  const defixedHeaders: TableColumn[] = [];

  tableConfig.columnConfig.columns.forEach((header: TableColumn) => {
    header.options.isFixed ? fixedHeaders.push(header) : defixedHeaders.push(header);
  });
  tableConfig.columnConfig.columns = [ ...fixedHeaders, ...defixedHeaders ];

  return tableConfig;
}

export const TABLE_SCOPE: InjectionToken<string> = new InjectionToken<string>("TABLE_SCOPE");
export function provideTableConfigService (tableScope: string, defaultConfig: TableConfig): Provider[] {
  if (!tableScope)
    throw new Error("tableScope cannot be an empty string");

  return [
    {
      provide: TABLE_SCOPE,
      useValue: tableScope
    },
    {
      provide: TABLE_DEFAULT_CONFIG,
      useValue: sortHeaders(defaultConfig)
    },
    {
      provide: TableConfigService
    },
    {
      provide: TableConfigStoreService
    }
  ];
}
